<template>
    <div class="d-flex flex-column mb-2">
        <label class="text-muted font-weight-bold">{{
            $t('nBox.goalWeightByLevel') + ':'
        }}</label>
        <div class="d-flex">
            <div
                class="d-flex"
                :key="`${i}-${level}`"
                v-for="(level, i) in levels"
            >
                <div>
                    <b-form-input
                        size="sm"
                        no-wheel
                        type="number"
                        class="input"
                        :value="model[level]"
                        :state="validations[level].isValid"
                        @input="onInputValue(level, $event)"
                    />
                    <small class="text-muted"> {{ levelsLabel[level] }}</small>
                </div>
                <b-input-group-prepend is-text v-if="i !== levels.length - 1"
                    >+</b-input-group-prepend
                >
                <b-input-group-append is-text v-if="i == levels.length - 1">{{
                    '= ' + totalWeight + '%'
                }}</b-input-group-append>
            </div>
        </div>
        <div>
            <b-form-invalid-feedback :state="showRequiredValidation">
                {{ $t('form.validations.required') }}
            </b-form-invalid-feedback>
            <b-form-invalid-feedback
                :state="showSumOfTargetLevelsWeightValidation"
            >
                {{ $t('nBox.form.validations.targetLevelsWeight') }}
            </b-form-invalid-feedback>
            <b-form-invalid-feedback :state="showMinValueValidation">
                {{ $t('form.validations.minValue', { value: 0 }) }}
            </b-form-invalid-feedback>
            <b-form-invalid-feedback :state="showMaxValueValidation">
                {{ $t('form.validations.maxValue', { value: 100 }) }}
            </b-form-invalid-feedback>
        </div>
    </div>
</template>
<script>
import i18n from '@/i18n'
export default {
    props: {
        personal_weight: {
            type: [Number, String],
            required: true,
        },
        team_weight: {
            type: [Number, String],
            required: true,
        },
        unit_weight: {
            type: [Number, String],
            required: true,
        },
        validations: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            model: {
                team_weight: this.team_weight,
                unit_weight: this.unit_weight,
                personal_weight: this.personal_weight,
            },
        }
    },
    computed: {
        showRequiredValidation() {
            return this.checkLevelsValuation('required')
        },
        showMinValueValidation() {
            return this.checkLevelsValuation('minValue')
        },
        showMaxValueValidation() {
            return this.checkLevelsValuation('maxValue')
        },
        showSumOfTargetLevelsWeightValidation() {
            return this.checkLevelsValuation('sumOfTargetLevelsWeight')
        },
        totalWeight() {
            return this.levels.reduce((acc, key) => {
                if (this.model[key]) {
                    return parseFloat(this.model[key]) + acc
                }
                return acc
            }, 0)
        },
        levelsLabel() {
            return {
                unit_weight: i18n.t('nBox.unit'),
                team_weight: i18n.t('groupLevel.department'),
                personal_weight: i18n.t('groupLevel.personal'),
            }
        },
        levels: () => ['personal_weight', 'team_weight', 'unit_weight'],
    },
    methods: {
        checkLevelsValuation(validation) {
            return this.levels.every(
                level => this.validations[level][validation] !== false
            )
        },
        onInputValue(level, value) {
            this.model[level] = value
            this.$emit('update', level, value)
        },
    },
}
</script>
<style scoped lang="sass">
.input
    min-width: 60px !important
    max-width: 80px !important
</style>
